import React, { ReactNode } from 'react';
import { Paragraph3 } from 'baseui/typography';
import { styled } from 'baseui';
import { TFunction } from 'i18next';

export interface ApiErrorProps {
    message?: string
    code?: number
    errors?: Record<string, string[]>
}

export class ApiError extends Error {
    code?: number
    errors?: Record<string, string[]>

    constructor({ message, code, errors }: ApiErrorProps) {
        super(message);
        this.code = code;
        this.errors = errors;
    }
}

const ErrorParagraph = styled(Paragraph3, () => ({
    margin: '0 0 5px 0',
    lineHeight: '1em',
    color: 'inherit',
}));

const ErrorsList = styled('ul', () => ({
    paddingLeft: '16px',
    marginTop: '8px',
}));

export const parseApiErrorToReadableMessage = (err: ApiError, tFunction?: TFunction, toString?: boolean): string | ReactNode => {
    if (err.errors) {
        const entries = Object.entries(err.errors);

        if (toString) {
            return entries.reduce<string[]>((acc, next) => [...acc, ...next[1].reduce<string[]>((acc, next) => [...acc, tFunction ? tFunction(next) : next], [])], []).join(" ")
        }
        
        return (
            <>
                {entries.map(([fieldName, errors]) => (
                    <>
                        {/* {<ErrorParagraph>
                            {tFunction ? tFunction(fieldName) : fieldName}
                        </ErrorParagraph>} */}
                        <ErrorsList>
                            {errors.map(error => (
                                <li key={error}>
                                    <ErrorParagraph>
                                        {tFunction ? tFunction(error) : error}
                                    </ErrorParagraph>
                                </li>
                            ))}
                        </ErrorsList>
                    </>
                ))}
            </>
        );
    }
    if (toString) {
        return tFunction ? tFunction(err.message) : err.message
    }
    return (
        <ErrorParagraph>
            {tFunction ? tFunction(err.message) : err.message}
        </ErrorParagraph>
    );
};

export function parseErrorToReadableMessage(err: string | Error | ReactNode | ApiError, tFunction?: TFunction): string | ReactNode {
    if (err instanceof ApiError)
        return parseApiErrorToReadableMessage(err, tFunction);

    if (err instanceof Error) {
        if (tFunction)
            return tFunction(err.message)

        return err.message;
    }

    if (tFunction && typeof err === 'string')
        return tFunction(err);

    return err;
}
